export default __webpack_public_path__ + "static/ionic-logo-blue-3748738d9977ac80cf3f66a88433eecc.png";